module.exports = __webpack_public_path__ + "Flama-Light.ttf?e4e98b9f08d653d2df7d7da593c81f17";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Light.ttf
// module id = 931
// module chunks = 0